import { Injectable } from '@angular/core';
import { ApiErrorService } from '../api-error.service';
import { HelperService } from '../helper/helper.service';
import { TxService } from '../shared/tx.service';
import { AccountService } from '../user/account.service';
import { SmartHttpService } from '../smart-http/smart-http.service';
import { LocalStorageService } from '../localStorage/localStorage.service';
import { localStorageKeys } from '../localStorage/localStorageVariables';

@Injectable({
  providedIn: 'root',
})
export class DynamicFormService {
  apiParams: any;
  selectedGuest: any;

  constructor(
    private httpClient: SmartHttpService,
    private helperService: HelperService,
    private envService: TxService,
    private accountService: AccountService,
    private apiErrorService: ApiErrorService,
    private localStorageData: LocalStorageService
  ) {
    this.initApiParams();
  }
  public get getUserInfo(): any {
    const userInfo =
      JSON.parse(this.localStorageData.getItem(localStorageKeys.USER_INFO)) ||
      {};
    const phoneNo = this.localStorageData.getItem(
      localStorageKeys.PHONE_NUMBER
    );

    return {
      ...userInfo,
      ...(userInfo.phoneNo ? {} : { phoneNo: phoneNo }),
    };
  }

  public get getTrackedFlights() {
    return JSON.parse(
      this.localStorageData.getItem(localStorageKeys.TRACKED_FLIGHTS)
    );
  }

  public formatDateString(dateString: string): string {
    // Parse the date string to a Date object
    const date = new Date(dateString);

    // Format the date to YYYY-MM-DD
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const day = ('0' + date.getDate()).slice(-2);

    return `${year}-${month}-${day}`;
  }

  public get dynamicFormApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    return (this.dynamicFormApi = `${this.envService.getDynamicFormApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`);
  }
  public set dynamicFormApi(value: string) {}

  initApiParams() {
    this.apiParams = {
      token: this.accountService.token,
    };
  }

  getDynamicForm(type: any) {
    this.apiParams.catlogType = type;
    this.apiParams.version = 2;
    return this.httpClient.getWithErorrHandler<any>(this.dynamicFormApi);
  }

  setSelectedGuest(item){
    this.selectedGuest = item;
  }

  getSeelctedGuest(){
    return this.selectedGuest;
  }
}
